import React, { FormEvent } from "react";
import { Box, FormControl, InputLabel, Select, MenuItem, Button, TextField, InputAdornment } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";

interface FiltersProps {
  chunkRange: string;
  onChunkRangeChange: (value: string) => void;
  onCreateClick?: () => void;
  search: string;
  onSearchChange: (value: string) => void;
  onSearch: (e: FormEvent<HTMLFormElement>) => void;
}

const Filters: React.FC<FiltersProps> = ({
  chunkRange,
  onChunkRangeChange,
  onCreateClick,
  search,
  onSearchChange,
  onSearch,
}) => {
  return (
    <Box
      component="form"
      onSubmit={onSearch}
      sx={{ display: "flex", gap: 1.5, mb: 3, alignItems: "center" }}
    >
      {/* Search field – grows to fill available space */}
      <TextField
        size="small"
        placeholder="Search guidelines…"
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        sx={{ flex: 1 }}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: "text.secondary" }} />
              </InputAdornment>
            ),
          },
        }}
      />

      {/* Chunk filter */}
      <FormControl size="small" sx={{ minWidth: 130 }}>
        <InputLabel id="chunk-filter-label">Chunks</InputLabel>
        <Select
          labelId="chunk-filter-label"
          value={chunkRange}
          label="Chunks"
          onChange={(e) => onChunkRangeChange(e.target.value)}
        >
          <MenuItem value="all">All</MenuItem>
          <MenuItem value="0">0</MenuItem>
          <MenuItem value="1-10">1 – 10</MenuItem>
          <MenuItem value="11-50">11 – 50</MenuItem>
          <MenuItem value=">50">50+</MenuItem>
        </Select>
      </FormControl>

      {/* Create guideline */}
      {onCreateClick && (
        <Button
          variant="contained"
          size="small"
          startIcon={<AddIcon />}
          onClick={onCreateClick}
          sx={(theme) => ({
            height: "40px",
            whiteSpace: "nowrap",
            backgroundColor: theme.palette.text.primary,
            color: theme.palette.background.paper,
            "&:hover": {
              backgroundColor: theme.palette.text.secondary,
            },
          })}
        >
          Create Guideline
        </Button>
      )}
    </Box>
  );
};

export default Filters;
